export default "__VITE_PUBLIC_ASSET__a217a35c__"